import { useQuery } from '@tanstack/react-query'
import { accountKeys, guestKeys } from '../../../../data/queryFactories'
import {
  showErrorToast,
  showLoadingToast,
  showSuccessToast,
  toastKey,
} from '../../../../utils/showToast'
import { accountService } from '../../../../service/AccountService'
import { convertUnixToDate } from '../../../../utils/conversion'
import { useParseQuery } from '../../../../hooks/useNav'
export function mapUserData(data) {
  return {
    uuid: data.uuid || null,
    id: data.schoolId || null,
    name: data.fullName || null,
    accountType: data.accountType || null,
    course: data.studentCourse || null,
    groups: (data.groups || []).map((item) => item.name).join(', '),
    schoolEmail: data.schoolEmail || null,
    personalEmail: data.personalEmail || null,
    phoneNumber: data.phoneNumber || null,
    className: data.className || null,
    faculty: null,
    school: null,
    status: data.status || null,
    totalPayment: data.totalPayment || 0,
    joinDate: convertUnixToDate(data.createdAt),
    major: data.major || null,
    activate: data.status === 'ACTIVE' ? 'Đã kích hoạt' : 'Chưa kích hoạt',
  }
}

export default function useGetGuestAccount() {
  const { queryParams } = useParseQuery()

  const { data, isLoading, error } = useQuery({
    queryFn: async () => {
      showLoadingToast('Đang tải', toastKey.ACCOUNT.GUEST.GET)

      const pageNumber = parseInt(queryParams?.pageNumber - 1) || 0
      const { success, message } = await accountService.getUsersGuest({
        ...queryParams,
        pageNumber,
      })

      if (!success) {
        throw new Error()
      }
      if (message && message.content && message?.content?.users) {
        showSuccessToast('Tải tài khoản thành công', toastKey.ACCOUNT.GUEST.GET)
        return {
          pageNumber: message.content.pageNumber + 1,
          pageSize: message.content.pageSize,
          totalItems: message.content.totalItems,
          users: (message?.content?.users ?? []).map(mapUserData),
        }
      }

      throw new Error('Không xác định')
    },
    queryKey: guestKeys.list(queryParams),
  })
  if (error) {
    showErrorToast({
      error: error.message,
      message: 'Lấy thông tin thất bại vui lòng liên hệ admin',
      toastId: toastKey.ACCOUNT.GUEST.GET,
    })
  }
  return { data, isLoading }
}
